import axios from 'axios';
import Cookies from "js-cookie";

const uploadFileToS3 = async ({ folder, file }) => {
  try {
    const fileName = file.name;
    const contentType = file.type;
    const token = Cookies.get("token");

    const res = await axios.get(`${process.env.NEXT_PUBLIC_BASE_URL}/s3/presigned-url?filename=${fileName}&folder=${folder}&contentType=${contentType}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const presignedUrl = res?.data?.url;
    const awsUrl = res?.data?.awsUrl;

    if (presignedUrl) {
      // Use the pre-signed URL to upload the file with a PUT request
      let response = await axios.put(presignedUrl, file, {
        headers: {
          'Content-Type': contentType,
        },
      });

      return awsUrl;
    } else {
      return null;
    }

  } catch (err) {
    console.log(err, 'err upload get signed url');
    return null;
  }
};

export const downloadFile = async (fileUrl, fileName) => {
  const fileKey = fileUrl.split('.com/')[1]; // Extract the file key from the URL

  try {
    const token = Cookies.get("token");

    const response = await axios.get(`${process.env.NEXT_PUBLIC_BASE_URL}/s3/download-file?fileKey=${encodeURIComponent(fileKey)}`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      responseType: "blob"
    });

    if (!response?.status === 200) {
      throw new Error('Failed to fetch file');
    }

    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || fileKey.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Error downloading the file:', error);
    return false;
  }
};

export default uploadFileToS3;
